/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import InputMask from 'react-input-mask';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { AcademyState, AcademyLive } from 'store/modules/academy_store/types';
import { subscribe } from 'store/modules/academy_store/actions';
import { academyDateTimeLabel } from 'services/academy_date';
import AcademyButton from 'components/atoms/academy_button';
import { Container } from './styles';

interface AcademySubscriptionModalProps {
  show: boolean;
  live: AcademyLive | null;
  onClose: () => void;
}

const AcademySubscriptionModal: React.FC<AcademySubscriptionModalProps> = ({
  show,
  live,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { profile } = useSelector<ApplicationState, ProfileState>((s) => s.storage.profile);
  const { request } = useSelector<ApplicationState, AcademyState>((s) => s.session.academy);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!show) return;
    setName(profile?.name || '');
    setEmail(profile?.email || '');
    setWhatsapp(`${profile?.ddd_cellphone || ''}${profile?.cellphone || ''}`.replace(/\D/g, ''));
    setSubmitted(false);
  }, [show, profile]);

  useEffect(() => {
    if (submitted && request.subscribe.loaded) onClose();
  }, [submitted, request.subscribe.loaded]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!live) return;

    const digits = whatsapp.replace(/\D/g, '');
    dispatch(
      subscribe({
        live_id: live.id,
        name,
        email,
        ddd: digits.slice(0, 2),
        phone: digits.slice(2),
      }),
    );
    setSubmitted(true);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Container>
        <button type="button" className="close-btn" onClick={onClose}>
          <i className="material-icons">close</i>
          Fechar
        </button>

        <form onSubmit={handleSubmit}>
          <div className="modal-grid">
            <div className="col-left">
              <div className="thumb">
                {live?.thumbnail_url && <img src={live.thumbnail_url} alt={live.title} />}
              </div>
              {live && (
                <>
                  <div className="live-title">{live.title}</div>
                  <div className="live-date">{academyDateTimeLabel(live.scheduled_at)}</div>
                </>
              )}
            </div>

            <div className="divider" />

            <div className="col-right">
              <h3>Inscrição</h3>

              {submitted && request.subscribe.error && (
                <div className="error">Não foi possível concluir a inscrição. Tente novamente.</div>
              )}

              <div className="form-group">
                <label htmlFor="academy-name">Nome</label>
                <input
                  id="academy-name"
                  className="form-control"
                  type="text"
                  placeholder="Seu nome"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="academy-email">E-mail</label>
                <input
                  id="academy-email"
                  className="form-control"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="academy-whatsapp">WhatsApp</label>
                <InputMask
                  mask="(99) 99999-9999"
                  value={whatsapp}
                  onChange={(e) => setWhatsapp(e.target.value)}
                >
                  {(inputProps: any) => (
                    <input
                      {...inputProps}
                      id="academy-whatsapp"
                      className="form-control"
                      type="tel"
                      placeholder="(00) 00000-0000"
                      required
                    />
                  )}
                </InputMask>
              </div>

              <AcademyButton type="submit" icon="event" block disabled={request.subscribe.loading}>
                {request.subscribe.loading ? 'Enviando...' : 'Confirmar Inscrição'}
              </AcademyButton>
            </div>
          </div>
        </form>
      </Container>
    </Modal>
  );
};

export default AcademySubscriptionModal;
